import { styled as muiStyled } from '@mui/material/styles'
import { ProfilesStyles } from 'pages/School/Profiles/Style'


// extends ProfilesStyles — overrides student display to show a rating table instead of chips
export const ReadingGroupsStyles = muiStyled(ProfilesStyles)(() => ({
    flexDirection: "column",
    padding: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
    '.groups-row': {
        display: "flex",
        flexDirection: "row",
        columnGap: 20,
        flex: 1,
        minHeight: 0,
        overflow: "auto",
    },
    '.secondary-toolbar': {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        flexShrink: 0,
        paddingBottom: 12,
        borderBottom: "1px solid #E5EFF8",
        marginBottom: 4,
    },
    '.secondary-toolbar-texts': {
        flex: 1,
        display: "flex",
        color: 'var(--Text-primary, #404F69)',
        fontSize: '16px',
        flexDirection: "column",
        gap: 2,
    },
    '.secondary-toolbar-title': {
        // fontWeight: 700,
        fontWeight: 400,
        lineHeight: 1.5,
    },
    '.secondary-toolbar-subtitle': {
        fontWeight: 400,
        lineHeight: 1.5,
    },
    '.profile-content-cards': {
        flexDirection: "column",
        padding: 0,
        border: "none",
        background: "transparent",
        rowGap: 0,
    },
    '.group-count': {
        fontSize: 12,
        color: "#666",
    },
    '.group-badges': {
        display: "flex",
        columnGap: 6,
        flexWrap: "wrap",
        rowGap: 4,
    },
    '.profile-section': {
        overflow: "hidden",
    },
    '.student-table': {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        padding: "0 0 4px 0",
    },
    '.table-header-row': {
        display: "flex",
        alignItems: "stretch",
        gap: 8,
        padding: "0 10px",
        background: "white",
        fontSize: 14,
        fontWeight: 400,
        color: "#404F69",
        flexShrink: 0,
        '& .col-name': {
            borderBottom: `1px solid #E5EFF8`,
            padding: "8px 0",
        },
        '& .col-rating': {
            borderBottom: `1px solid #E5EFF8`,
            padding: "8px 0",
        },
    },
    '.student-row': {
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "5px 10px",
        borderBottom: `1px solid #F0F4F8`,
        flexShrink: 0,
        '&:last-child': {
            borderBottom: "none",
        },
    },
    '.student-group-card': {
        background: "white",
        border: `1px solid #E5EFF8`,
        borderRadius: 12,
        overflow: "hidden",
        flexShrink: 0,
    },
    '.col-name': {
        flex: "1 0 0",
        minWidth: 0,
        fontSize: 13,
        wordBreak: "break-word",
    },
    '.col-rating': {
        flex: "1 0 0",
        minWidth: 0,
        display: "flex",
        alignItems: "center",
        gap: 4,
        justifyContent: "flex-start",
        overflow: "hidden",
    },
}))
